module.exports = __webpack_public_path__ + "img/graduated-3-min.2557102f.png";